module.exports = __webpack_public_path__ + "static/media/pre-page.6fdca449.svg";